import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { searchVendorPayments } from '../../../api/vendorPayment';
import { raiseToast } from '../toast/toast';
import { getSearchActiveStatus } from '../../../../utils';

export const fetchVendorPaymentsPettyCash = createAsyncThunk('user/getVendorPaymentsPettyCash', async (params, {dispatch}) => {
    const response = await searchVendorPayments(params)

    if(response.failure){
        dispatch(raiseToast({severity:'error', detail: response.data.error, life: 3000}))
        throw Error("error")
    }
    return response
})

export const vendorPaymentPettyCashSlice = createSlice({
    name: "user/getVendorPaymentsPettyCash",
    initialState: {
        loading: false ,
        vendorPaymentsPettyCashData: [],
        bookingLogs: [],
        paginationParams : {
            pageNo: 0,
            totalRecords: 0,
            recordsPerPage: 10,
            limitedPagination: true,
            getCount: true,
            paginator: true
        },
        searchParams: {
            dataType: "vendorPaymentsData",
            pettyCashFlag: true,
            searchBy: "all",
            searchText: "",
            dateType: "createdAt"
        },
        searchOptions: [],
        isSearchVisible: true,
        isSearchActive: false,
        searchConfig: []
    },
    reducers: {
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload
            const parsedState = JSON.parse(JSON.stringify(state))

            const isSearchActive = getSearchActiveStatus(parsedState.searchParams, parsedState.searchConfig)

            state.isSearchActive = isSearchActive
        },
        updateVendorPaymentPettyCashData: (state, action) => {
            state.vendorPaymentsChequesData = action.payload
        },
        setIsSearchVisible: (state, action) => {
            state.isSearchVisible = action.payload
        },
        setSearchConfig: (state, action) => {
            state.searchConfig = action.payload
        },
        updateSearchByParam: (state, action) => {
            const parsedState = JSON.parse(JSON.stringify(state))
            const availableOptions = parsedState.searchConfig.map(eachOption => eachOption.name)
            if(availableOptions.includes(action.payload.searchBy)){
                state.searchParams = {...parsedState.searchParams, ...action.payload}
            } else {
                state.searchParams = {...parsedState.searchParams, searchBy: "all", searchText: ""}
            }
        }
    },
    extraReducers : (builder) => {
        builder.addCase(
            fetchVendorPaymentsPettyCash.fulfilled, (state, action) => {
                state.loading = false 
                state.vendorPaymentsPettyCashData = action.payload.data.data
                state.bookingLogs = action.payload.data.bookingLogs
                state.paginationParams.pageNo = action.payload.data.pageNo-1
                state.paginationParams.recordsPerPage = action.payload.data.recordsPerPage
                if(action.payload.data.totalRecords || action.payload.data.totalRecords === 0){
                    state.paginationParams.totalRecords = action.payload.data.totalRecords
                }
                if(state.vendorPaymentsPettyCashData.length){
                    state.isSearchVisible = false
                }
            }
        )
        .addCase(
            fetchVendorPaymentsPettyCash.pending, (state, action) => {
                state.loading = true 
            }
        )
        .addCase(
            fetchVendorPaymentsPettyCash.rejected, (state, action) => {
                state.loading = false
            }
        )
    }
    })


export const { updateSearchParams, updateSearchOptions, updateVendorPaymentPettyCashData, setIsSearchVisible, setSearchConfig } = vendorPaymentPettyCashSlice.actions

export default vendorPaymentPettyCashSlice.reducer